const dataTestIds = {
  articleLoader: "article-loader",
  articleBody: "article-body",
  breadcrumb: {
    default: "breadcrumb",
    loader: "breadcrumb-loader",
  },
  category: {
    heading: "category-heading",
  },
  escalationModal: {
    additionalInfo: "#escalationRequestModal-compositeTextArea-additionalInfo",
    nudgeRadioButton: 'input[value = "esc_type_nudge"]',
  },

  getAttachmentByTitle: (filename: string) => `[title="${filename}"]`,
  pasteChatLog: '[data-paste-element="CHAT_LOG"]',
  pasteChatMessage: '[data-paste-element="CHAT_MESSAGE"]',
  headingLoader: "heading-loader",
  section: {
    articleCard: "section-article-card",
    articleCardsLoaders: "article-cards-loaders",
    articleViewingCount: "article-viewing-count",
    cards: "section-cards",
    currentPageButton: "pagination-number-button",
    heading: "section-heading",
    nextButton: "pagination-next-button",
    previousButton: "pagination-previous-button",
  },
  errorState: "error-state",
  productCard: {
    articleCount: "product-card-article-count",
    default: "product-card",
    loaders: "product-card-loaders",
    sectionTitle: "product-card-title",
  },
  productCards: "product-cards",
  productSwitcherButton: '[data-paste-element="PRODUCT_SWITCHER_BUTTON"]',
  pasteAnchor: '[data-paste-element="ANCHOR"]',
  pasteHeading: '[data-paste-element="HEADING"]',
  // TODO: Replace with data-testid with Services Common changes
  search: "#support-search",
  navigation: {
    header: 'div[data-paste-element="TOPBAR"]',
    userDropdown: 'svg[aria-labelledby*="UserIcon"]',
  },
  supportPlansBadge: "supportPlansBadge",
  systemStatusButton: "systemStatusButton",
  accountSwitcher: {
    accountSwitcherMenu: {
      dropdown: '[data-testid="account-switcher-menu"]',
      menuCurrentAccount: "account-switcher-menu-current-account",
      menuBadge: "account-switcher-menu-badge",
    },
    accountSwitcherTable: {
      table: "account-switcher-table",
    },
  },
  subaccounts: {
    table: "subaccounts-table",
    tableControls: "subaccounts-table-controls",
  },
  wiseOwlChat: {
    helpAssistantMediaObject: "help-assistant-media-object",
    chatComposer: "chatComposer-chat-composer",
    feedbackForm: "feedback-text-area",
    feedbackSubmitted: "feedback-feeback-submitted",
    promptSuggestion: {
      heading: "promptSuggestion-heading",
      category: "promptSuggestion-category",
    },
    submitButton: "wiseOwlChat-submit-button",
    thumbsDownFeedback: "feedback-thumbs-down",
    toolCallStatusLine: "tool-call-status-line",
    userMediaObject: "user-media-object",
  },
  liveChat: {
    chatComposer: "live-chat-composer",
    submitButton: "live-chat-submit-button",
  },
};

export { dataTestIds };
